<app-page-title>
</app-page-title>

<p-scrollPanel [style]="{ width: 'calc(100vw - 268px)', height: '70px' }">
  <med-tab-group
          [options]="optionsTabGroup"
          [(value)]="optionsModel"
          (valueChange)="tabGroupChanged($event)">
      <ng-template medTemplate="tab" let-option>
         <div style="width: max-content; display: flex;">
          <med-icon-check  size="16" class="text-green-100" *ngIf="option.value.checked"></med-icon-check>
          &nbsp;
          <span class="truncate-15em">{{option.label}}</span>
          <span *ngIf="option.value.dosage">
              |&nbsp;{{option.value.dosage}}
          </span>
      </div>
      </ng-template>
  </med-tab-group>
    </p-scrollPanel>

<div class="background-249 flex justify-content-start mt-2 mb-2 p-2" style="border: 1px solid #c7c7c7; width: calc(100vw - 268px);
  border-radius: 5px;">
  <div class="mr-3 h10-text black-60">LOV ID: <span class="black-80">{{optionsModel?.lovId}}</span></div>
  <div class="mr-3 h10-text black-60">МНН ID: <span class="black-80">{{optionsModel?.mnnId}}</span></div>
  <div class="mr-3 h10-text black-60" style="display: flex">МНН:&nbsp;<div class="black-80 truncate-15em">{{optionsModel?.mnnName}}</div></div>
  <div class="mr-3 h10-text black-60">Дозування: <span class="black-80">{{optionsModel?.dosage}}</span></div>
  <div class="mr-3 h10-text black-60">Кратність: <span class="black-80">{{optionsModel?.multiple}}</span></div>
  <div class="mr-3 h10-text black-60">Вартість за одиницюб грн: <span class="black-80">{{optionsModel?.cost}}</span></div>
  <div class="mr-3 h10-text black-60">Одиниця виміру: <span class="black-80">{{optionsModel?.unit}}</span></div>
  <div class="mr-3 h10-text black-60">Залишок у запасі: <span class="black-80">{{optionsModel?.remainQuantity}}</span></div>
</div>

<div style="margin-bottom: 108px" class="accordion-wrapper">
  <p-accordion [(activeIndex)]="activeIndex" (onOpen)="onAccordionOpen($event)">
    <p-accordionTab
      *ngFor="let recipient of activeDistributionRecipients; let i = index"
      iconPos="start"
      [headerStyleClass]="getHeaderClass(i)">
      <ng-template pTemplate="header">
        <div class="flex w-full">
          <div class="h9-text">{{ recipient.recipientName }}</div>
          <div class="black-60 flex flex-between justify-content-center" style="margin-left: auto;">
            <div class="h10-text flex align-items-center mr-2">Розподілено:</div>
            <med-bubble [styleClass]="'med-bubble-dark-purple'">
              <div class="h10-text">
                <span style="color: #fff">{{recipient.multiplicity}}</span>
                <span style="color: #c7c7c7">/{{recipient.distributedProportional}}</span>
              </div>
            </med-bubble>
          </div>
        </div>
      </ng-template>

      <ng-template pTemplate="body">
        <ng-container *ngIf="currentRecipientId === recipient.id">
          <ng-container *ngIf="selectedSeries.length === 0; else tableTemplate">
            <div class="mt-4 flex flex-center">
              <span class="black-40 h10-text">Немає доданих</span>
              &nbsp;
              <med-btn (click)="openAddSeriesModal()" skin="gray" size="small">
                <med-icon-plus size="16"></med-icon-plus>
              </med-btn>
            </div>
          </ng-container>
          <ng-template #tableTemplate>
            <div>
              <p-table
                [ngStyle]="{ 'display': 'block' }"
                styleClass="p-datatable-sm"
                [scrollable]="true"
                scrollHeight="flex"
                [value]="selectedSeries"
                [columns]="tabHeader"
                [customSort]="true"
                [lazy]="true"
                [resizableColumns]="true">
                <ng-template pTemplate="header">
                  <tr>
                    <ng-container *ngFor="let column of tabHeader">
                      <th class="table-header-text" style="background-color: rgb(249, 249, 249)!important;" pResizableColumn>
                          <div style="display: inline-block" class="flex align-items-center">
                              {{ column.label }}&nbsp;
                          </div>
                      </th>
              </ng-container>
                  </tr>
                </ng-template>

                <ng-template pTemplate="body" let-row let-columns="columns">
                  <tr class="table-content-text">
                    <ng-container *ngFor="let col of columns">
                      <td class="h10-text black-80" *ngIf="col.key === '1'">
                        {{ row.seriesCatalogue }}
                      </td>
                      <td class="h10-text black-80" *ngIf="col.key === '2'">
                        {{row.manufactureDate}}
                      </td>
                      <td class="h10-text black-80" *ngIf="col.key === '3'">
                         {{ row.dueDate }}
                      </td>
                      <td class="h10-text black-80" *ngIf="col.key === '4'">
                          {{ row.totalQuantity }}
                      </td>

                      <td class="h10-text black-80" *ngIf="col.key === '5'">
                        {{row.totalDistributedQuantity}}
                      </td>
                      <td class="h10-text black-80" *ngIf="col.key === '6'">
                        {{row.availableQuantity}}
                      </td>
                      <td class="h10-text black-80" *ngIf="col.key === '7'">
                        {{row.totalSpecifications}}
                      </td>
                      <td class="h10-text black-80" *ngIf="col.key === '8'">
                        <med-input  [size]="'small'" [(ngModel)]="row.quantity"
                        (ngModelChange)="onQuantityChange(row.distributionRecipientSpecificationId, row.quantity)"></med-input>
                      </td>
                      <td *ngIf="col.key === '9'">
                        <med-icon-delete [ngStyle]="{'width': '16px', 'cursor': 'pointer'}"  (click)="deleteSeries(row.distributionRecipientSpecificationId)"></med-icon-delete>
                      </td>
                  </ng-container>
                  </tr>
                </ng-template>
              </p-table>
              <div style="height: 48px; padding: 16px; background-color: #FFFFFF;">
                <med-btn  class="plus-btn" (click)="openAddSeriesModal()" skin="gray" size="small">
                  <med-icon-plus size="16"></med-icon-plus>
                </med-btn>
              </div>
            </div>
          </ng-template>
        </ng-container>
      </ng-template>

    </p-accordionTab>
  </p-accordion>
</div>


<div
        [style.width]="'calc(100vw - 0px)'"
        [style.height]="'60px'"
        class="med-layout__footer"
>
    <div class="med-layout__footer-content">
        <div class="flex flex-center flex-between">
            <div class="flex flex-center">
                <med-btn class="mr-1" (click)="goToDistribution()">
                    <med-icon-reply size="16"></med-icon-reply>
                    &nbsp;
                    <span>До розподілу</span>
                </med-btn>
            </div>
            <div class="flex flex-center">
                <med-btn skin="yellow" (click)="update()">
                    <span>Застосувати вибір</span>
                    &nbsp;
                    <med-icon-check size="16"></med-icon-check>
                </med-btn>
            </div>
        </div>
    </div>
</div>

<med-modal [(visible)]="addSeriesModal" [closeableOutside]="false" [showCloseBtn]="false">
  <div [style]="{ width: '480px', height: '526px' }" class="flex flex-column">
    <div class="inline-flex align-items-start justify-content-start gap-2">
      <p-avatar
        [style]="{width: '1.5em', height: '1.5em'}"
        styleClass="mr-2"
        image="assets/icons/big_plus.png"
        shape="circle" />

      <span class="H6-Heading white-space-nowrap">
                    Додати Cерію/Каталожний номер
                </span>
      <div style="margin-left: auto; color: #666666; cursor: pointer" (click)="addSeriesModal = false">
        <med-icon-close></med-icon-close>
      </div>
    </div>
    <div style="display: flex; flex-direction: column; height: 100%" class="mt-4">
      <div class="mobile-h10-text" style="padding-bottom: 1em">
        Регіон
      </div>
      <div class="h10-text black-80" style="padding-bottom: 3em">
        {{ getCurrentRegionName() }}
      </div>
      <div class="mobile-h10-text" style="padding-bottom: 1em">
        Серія/Каталожний номер
      </div>
      <div>
        <p-multiSelect
          [overlayVisible]="false"
          [style]="{ width: '100%', height: '8rem' }"
          [options]="allSeries"
          [(ngModel)]="activeSelectedSeries"
          [maxSelectedLabels]="7"
          placeholder="Оберіть серію"
          optionLabel="seriesCatalogue"
          display="chip"/>
      </div>
    </div>

    <div style="margin-top: auto; display: flex; flex-direction: row">
      <div style="width: 48%;">
        <med-btn skin="gray" (click)="addSeriesModal = false">Скасувати</med-btn>
      </div>
      <div style="width: 48%; margin-left: auto">
        <med-btn [disabled]="false" (click)="accept()">Підтвердити</med-btn>
      </div>
    </div>

  </div>
</med-modal>
